import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";
import App from "./App";
import { applySelectionFix } from "./lib/selectionFix";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Restore native text selection behavior for inputs (in case something disables it globally).
applySelectionFix();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: register service worker in production
serviceWorkerRegistration.register();
